import React from 'react'
import './style.scss'
import SEO from './seo'
import Navbar from './navbar'
import Footer from './footer'

const Layout = ({ children, title, description, lang }) => {
	return (
	<>
		<SEO
			title={title}
			description={description}
			lang={lang}
		/>
    <Navbar
			lang={ lang }
		/>
			{ children }
    <Footer />
	</>
	)
}

export default Layout